import React from "react";
import { Oval } from "react-loader-spinner";

import styles from './index.module.scss';

export default function RcmpLoading(props) {
  const { bShow, className, size, color = "#4C7F9F", ...oRest } = props;

  if (!bShow) return null;

  const nSize = size ? size : 80

  const containerClasses = `${styles.loadingContainer} ${className ? className : ""}`

  return (
    <div className={containerClasses}>
      <Oval
        height={nSize}
        width={nSize}
        color={color}
        visible={true}
        ariaLabel="oval-loading"
        secondaryColor="#6CB6E3"
        strokeWidth={5}
        strokeWidthSecondary={3}
        {...oRest}
      />
    </div>
  )
}